module.exports = __webpack_public_path__ + "img/transparente.d6f8ac5e.png";